/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../../core/app-context/GeneralContext';
import { RESEND_ORDER_CODE } from './graphql';

export function useResendOrderCode() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [ResendOrderCode, { loading: apiLoading, error: apiError }] =
    useMutation(RESEND_ORDER_CODE);

  useEffect(() => {
    setErrorMessage(apiError);
  }, [apiError]);

  useEffect(() => {
    setIsLoading(apiLoading);
    setLoading(apiLoading);
  }, [apiLoading]);

  async function resendOrderCode({ orderId }) {
    try {
      const res = await ResendOrderCode({
        variables: { orderId },
      });
      if (res.data.resendOrderCodeEmail.code !== 200) {
        setErrorMessage(res.data.resendOrderCodeEmail.message);
      } else {
        setSuccessMessage(res.data.resendOrderCodeEmail.message);
      }
    } catch (e) {
      setErrorMessage(e.message);
    }
  }

  return {
    resendOrderCode,
    loading: isLoading,
  };
}
